import type { DevSettings } from '../devSettings/devSettings.types';

export const createShareableDevUrl = ({
  baseUrl,
  devSettings,
}: {
  baseUrl: string;
  devSettings: DevSettings;
}): string => {
  const url = new URL(baseUrl);
  const params = new URLSearchParams(url.search);

  params.set('environmentId', devSettings.environmentId);
  params.set('apiBaseUrlOrigin', devSettings.apiBaseUrlOrigin);
  params.set('apiBaseUrlPath', devSettings.apiBaseUrlPath);
  params.set('extensions', JSON.stringify(devSettings.extensions));

  url.search = params.toString();

  return url.toString();
};
